/**
 * preferenceManagement-stackを利用する時はこのコードを組み込んでください。基本的にコピペでOKです。
 */

/**
 * preferenceManagement-stackは、ロジックに'@/appLogic/stacks/preferenceManagement'を利用できます
 * preferenceManagement-stackのDynamoDBは、Hasykeyが"ownerName"、Rangekeyが"kind"というキー名が定義されます。
 * また、updatedAtがLSIのRangekeyにセットされています。
 * さらに、removeAtというキー名をTTLに設定しているので、レコードにremoveAt（UNIXTIME秒）をセットして登録するとその時刻に自動的に削除されます。
 * これらの機能に加えて、案件ごとにデータをまとめてS3にアーカイブしたり、S3からDynamoDBにデータを復元する機能も含まれます。
 *
 * appLogic-simple-data-managementは、@zettant/cacheManageモジュールを利用しており、その機能のうち限定的な部分だけを提供しています。
 * 基本的なデータの制御はcache-manageに任されており、putPreferenceやgetPreferenceなどの基本的な操作だけができるようになっています。
 */

import {preparePreferenceTable, getPreferenceTable} from './preferenceManage';
import {initPreferenceWithDummyDriver} from './dummyDrivers/initPreferenceDriver';
import {allLocalTableClear} from './dummyDrivers/dummyDriver';

let tableName = '';
const getTableName = () => tableName;


const initSingleTable = async (name: string, useDummyDriver: boolean) => {
  tableName = name;
  if (useDummyDriver) {
    await initPreferenceWithDummyDriver(tableName);
  } else {
    await preparePreferenceTable(tableName, undefined, 86400 * 30);  // TODO: 本番はこっち
  }
};

const tableClear = async () => {
  const table = await getPreferenceTable();
  await table.flush();
  await allLocalTableClear(); // dummyDriverを組み込んでいるときだけ、中の関数が定義されている
};

export {getTableName, initSingleTable, tableClear};
